export const VIEWPORT_WIDTH: string = "600px";
export const INPUT_PLACEHOLDER: string = "What's up ? ...";
export const TASKS_STORAGE_KEY: string = "tasksStorage";
